<template>
  <div>
    <div v-if="state !== 'fixed'" v-for="(lamp, d) in myLamps" :key="d" :class="lamp" :style="getStyle()" class="ma-1">
    </div>
    <div v-if="(state === 'fixed' && (this.color))" :style="getStyle()" class="lampTranparent ma-1">
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'TrafficLight',
  props: ['cnt', 'state', 'color'],
  components: {},
  methods: {
    getStyle: function () {
      var s = 'background-color:#' + this.color + ';'
      Vue.prototype.$api.debug('s', s)
      return s
    },
    setStatusOnThreeLamps: function () {
      if (this.state === -1) {
        this.myLamps = ['lampWhite', 'lampWhite', 'lampRed']
      }
      if (this.state === 0) {
        this.myLamps = ['lampWhite', 'lampYellow', 'lampWhite']
      }
      if (this.state === 1) {
        this.myLamps = ['lampGreen', 'lampWhite', 'lampWhite']
      }
    },
    setStatusOnTwoLamps: function () {
      if (this.state === -1) {
        this.myLamps = ['lampWhite', 'lampRed']
      }
      if (this.state === 0) {
        this.myLamps = ['lampWhite', 'lampWhite']
      }
      if (this.state === 1) {
        this.myLamps = ['lampGreen', 'lampWhite']
      }
    },
    onClickTrafficLight: function () {
      this.lampCnt = this.cnt
      if (this.lampCnt === 3) {
        this.setStatusOnThreeLamps()
      }
      if (this.lampCnt === 2) {
        this.setStatusOnTwoLamps()
      }
    },
  },
  data () {
    return {
      lampCnt: 3,
      trafficlightRed: true,
      trafficlightGreen: true,
      myLamps: []
    }
  },
  mounted () {
    this.myLamps = ['lampWhite', 'lampWhite', 'lampRed']
    window.setTimeout(this.onClickTrafficLight, 400)
  }
}
</script>

<style scoped>

</style>


{"mail":"Folgender Fehler ist aufgetreten: Datenbankfehlernummer: 1054 Datenbankfehlertext: Unknown column "position.referenzPositionNr" in "field list" Query: SELECT pskb.BerichtsbereichNr, pskb.ID, FarbeHintergrund, FarbeSchrift, Seitenumbruch, TextdarstellungNr, UnterreiterNr, pts.Bezeichnung AS Name, mpt.Berechnungsebene AS Level, position.referenzPositionNr FROM ratingStruktur.positionStrukturpositionKennzahlBerichtAuftraggeber AS pskb LEFT JOIN ratingStruktur.positionTaxonomySprache AS pts ON (pts.PositionNr=pskb.ID AND pts.SpracheNr=1 AND pts.TaxonomyNr=1) LEFT JOIN ratingStruktur.monetaerePositionTaxonomy AS mpt ON (mpt.PositionNr=pskb.ID AND mpt.TaxonomyNr=1) LEFT JOIN ratingStruktur.Position ON (pskb.ID=position.PositionNr) WHERE BerichtNr=199 AND AuftraggeberNr=463 AND ReiterNr=2 ORDER BY Reihenfolge "}



// WEBPACK FOOTER //
// src/components/widgets/TrafficLight.vue